import { create } from '@storybook/theming/create';

export default create({
  base: 'dark',
  brandTitle: 'Ticker',
  brandUrl: 'https://ticker.app',
  brandImage: 'https://www.ticker.app/images/ticker-logo.svg',
  brandTarget: '_self',
  colorPrimary: '#091b38',
});